// SFI Agreement
$(document).ready(function() {
	
	if ($('.sfi-declaration-form').length) {
		var $form = $('.sfi-declaration-form');
		$form.find('#bc-submitted').change(function() {
			var bcSubmitted = ($(this).val() == 'yes');
			if (bcSubmitted) {
				$form.find('#receipt-number').prop('required',true).closest('.cell').show();
				$form.find('#declaration-pdf').prop('required',true).closest('.cell').show();
				$form.find('#declaration-fee').prop('required',true).closest('.cell').show();
			} else {
				$form.find('#receipt-number').prop('required',false).closest('.cell').hide();
				$form.find('#declaration-pdf').prop('required',false).closest('.cell').hide();
				$form.find('#declaration-fee').prop('required',false).closest('.cell').hide();
			}
		}).trigger('change');
	}
	
	
	if ($('#sfi-fields-container').length) {
		
		
		$(document).on('submit', '.sfi-ajax-form', function(e) {
			e.preventDefault();
			var $form = $(e.currentTarget);
			submitSfiAjaxForm($form).catch(function(error) {console.log(error)});
		});

		$(document).on('keyup change','.sfi-ajax-form .sfi-value',function(e) {
			updateSfiPayment($(e.currentTarget).closest('.sfi-ajax-form'));
			
			$('#sfi-agreement-total').html(totalAgreementPayment().toLocaleString(undefined, {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2,
			}));
		})
		$(document).on('change','.sfi-ajax-form .sfi-addition',function(e) {
			updateSfiPayment($(e.currentTarget).closest('.sfi-ajax-form'));
		});
		$(document).on('click','.sfi-ajax-form .delete-sfi-code',function(e) {
			var $form = $(e.currentTarget).closest('.sfi-ajax-form');
			$form.removeClass('saved');
			submitSfiAjaxForm($form).catch(function(error) {console.log(error)});
		});
		$(document).on('click','.sfi-ajax-form .refresh-sfi-code',function(e) {
			var $form = $(e.currentTarget).closest('.sfi-ajax-form');
			$form.removeClass('saved');
			submitSfiAjaxForm($form).catch(function(error) {console.log(error)});
		});
		
		$('#sfi-form .sfi-submit').click(function(e) {
			var $button = $(e.currentTarget);
			if ($button.hasClass('sfi-submit-continue')) {
				$('#sfi-form .save-continue-submit').val('1');
				$('#sfi-form .save-exit-submit').val('');
			} else {
				$('#sfi-form .save-continue-submit').val('');
				$('#sfi-form .save-exit-submit').val('1');
			}
			$('#sfi-form').submit();
		})
		
		$('#sfi-form').submit(function(e) {
			var $pageForm = $(this);
			e.preventDefault();
			if (!$pageForm.hasClass('submitting')) {
				$pageForm.addClass('submitting')
				var $unsubmittedAjaxForms = $('.sfi-ajax-form:not(.saved), .sfi-ajax-form.inactive');
				if (!$unsubmittedAjaxForms.length) {
					// if no forms have been updated, submit the form
					console.log("no unsubmitted forms, submitting page form");
					$pageForm.off('submit').submit();
					return;
				}
				var $submitButtons = $pageForm.find('input.sfi-submit');
				$submitButtons.each(function(i,b) {
					$(b).data('text', $(b).val());
					$(b).val("Saving...");
				})
				Promise.all($unsubmittedAjaxForms.map(function() {
					return submitSfiAjaxForm($(this));
				})).then(function() {
					console.log("all forms submitted, submitting page form");
					$pageForm.off('submit').submit();
					return;
				}).catch(function() {
					alert("Some values could not be submitted, please check any errors and try again");
					$submitButtons.each(function(i,b) {
						$(b).val($(b).data('text'));
					})
					$pageForm.removeClass('submitting');
				});
			}
		});
		
		$('.toggle-sfi-scheme-toolbar').on('click', function() {
			$('#sfi-scheme-tool').toggle(100);
			$('.sfi-tool-button').toggle(100);
		});

		$('#sfi-accordion-container').on('change', '.sfi-scheme-action', function() {
			var $this = $(this);
			var schemeId = $this.data('sfi-scheme-id');
			var code = $this.data('sfi-scheme-code');
			var yearId = $this.closest('.sfi-scheme-year').data('sfi-scheme-year-id');
			var year = $this.closest('.sfi-scheme-year').data('sfi-scheme-year');
			var $groupAccItem = $this.closest('.sfi-scheme-group');
			//console.log("$groupAccItem",$groupAccItem);
			var groupId = $groupAccItem.data('sfi-scheme-group-id');
			//console.log("groupId",groupId);
			var $schemeForm = $('#sfi-ajax-form-'+schemeId);
			// get / create the group container
			var groupTitle = $groupAccItem.find('.accordion-title').html();
			var $groupContainer = getGroupContainer(yearId,groupId,groupTitle);
			$('#sfi-agreement-year').html(year+' SFI Agreement').show();
			if ($this.prop('checked')) {
				// make sure the group and year container is not hidden
				$groupContainer.show().closest('.sfi-agreement-year').show();
				// disable any other years
				$('.sfi-scheme-year').each(function() {
					var $yearAccItem = $(this);
					if ($yearAccItem.data('sfi-scheme-year-id') != yearId) {
						//console.log("disabling accordion for "+$yearAccItem.data('sfi-scheme-year-id'));
						$yearAccItem.find('ul.accordion').each(function() {
							var $groupToDisable = $(this);
							$groupToDisable.attr('disabled','');
						});
					}
				});
				// check if the scheme ajax form is already in the dom
				if ($schemeForm.length) {
					// form already exists, set it to visible by removing the inactive class
					$schemeForm.removeClass('inactive');
				} else {
					// form not present in the dom, retrieve it via ajax
					$.ajax({ 
						url : '/ajax/library/retrieve-sfi-scheme',
						type : "POST",
						contentType : 'application/json',
						data : JSON.stringify({schemeId: schemeId})
					}).done(function(response) {
						$schemeForm = $(response.html);
						var inserted = false;
						$groupContainer.find('.sfi-ajax-form').each(function() {
							var $currentForm = $(this);
							var currentCode = $currentForm.data('sfi-scheme-code');
							if (code.localeCompare(currentCode) < 0) {
								$schemeForm.insertBefore($currentForm);
								inserted = true;
								return false;
							}
						});
						if (!inserted) {
							$schemeForm.appendTo($groupContainer);
						}
					});
				}
				console.log("enabling active");
				$('input.sfi-submit-continue').prop('disabled',false);
			} else {
				$schemeForm.addClass('inactive');
				// check if the year is still populated
				if (!sfiSchemeGroupPopulated(yearId, groupId)) {
					//console.log("Group "+groupId+" is no longer populated, hiding group on page");
					$groupContainer.hide();
					if (!sfiSchemeYearPopulated(yearId)) {
						console.log("Year "+yearId+" is no longer populated, hiding year on page");
						// hide the year container
						$groupContainer.closest('.sfi-agreement-year').hide();
						$('#sfi-agreement-year').html('SFI Agreement');
						// re-enable other years
						$('.sfi-scheme-year').each(function() {
							var $yearAccItem = $(this);
							$yearAccItem.find('ul.accordion').each(function() {
								var $groupToEnable = $(this);
								$groupToEnable.removeAttr('disabled');
							})
						});
				console.log("disabling active");
						$('input.sfi-submit-continue').prop('disabled',true);
					}
				}
			}
		});
	
		$('#searchSfi').on('keyup', Foundation.util.throttle(function() {
			var $this = $(this);

			var $container = $('#sfi-accordion-container');
			$container.addClass('fade-out-load');
			var $accordionUl = $('#sfi-ul-wrapper');
			var data = {
				searchQuery: $this.val()
			};
			if ($container.data('project') == 'ffr') {
				data.interventionId = $('.report-entry').data('intervention-id');
			} else if ($container.data('project') == 'sfi') {
				data.sfiAgreementId = $('.sfi-agreement').data('sfi-agreement-id');
			} else {
				$accordionUl.append('<p class="library-event-message alert callout">Error! Unable to determine project type</p>');
				$container.removeClass('fade-out-load');
				throw new Error('Unable to determine project type'); 
			}
			$.ajax({
				url : '/ajax/library/search-sfi-schemes',
				type : 'POST',
				contentType : 'application/json',
				data : JSON.stringify(data)
			}).done(function(result) {
				var $html = $(result.content);
				var numCategories = $html.find('.accordion-item').length;
				$accordionUl.empty();			
				if (numCategories > 0) {
					$accordionUl.append($html);		
					$('#sfi-schemes-accordion').foundation();			
				} else {
					$accordionUl.append('<p class="library-event-message alert callout">No results found</p>');
				}
				$container.removeClass('fade-out-load');
			});

			// Foundation - throttle the event handler, 500ms
		}, 500));
		
	}
	
	
});

/**
* sfiSchemeYearPopulated
*
* checks whether the year provided includes any selected actions 
*/
function sfiSchemeYearPopulated(yearId) {
	var populated = false;
	$('.sfi-agreement-year[data-sfi-scheme-year-id="'+yearId+'"] .sfi-ajax-form').each(function() {
		if (!$(this).hasClass('inactive')) {
			populated = true;
			return;
		}
	});
	return populated;
}

/**
* sfiSchemeGroupPopulated
*
* checks whether the year provided includes any selected actions 
*/
function sfiSchemeGroupPopulated(yearId, groupId) {
	var populated = false;
	$('.sfi-agreement-year[data-sfi-scheme-year-id="'+yearId+'"] .sfi-agreement-group[data-sfi-scheme-group-id="'+groupId+'"] .sfi-ajax-form').each(function() {
		if (!$(this).hasClass('inactive')) {
			populated = true;
			return;
		}
	});
	return populated;
}

/**
* getGroupContainerHtml
*
* adds a group container div to the dom if necessary or returns an existing container
**/
function getGroupContainer(yearId, groupId, groupTitle) {
	var $container = $('#sfi-agreement');
	// check if the year container already exists in the dom
	var $yearContainer = $container.find('.sfi-agreement-year[data-sfi-scheme-year-id="'+yearId+'"]');
	if (!$yearContainer.length) {
		// the year container doesn't yet exist for this agreement, add it to the container
		$yearContainer = $('<div class="sfi-agreement-year" data-sfi-scheme-year-id="'+yearId+'"></div>');
		$yearContainer.appendTo($container);
	}
	// check if the group container already exists in the dom
	var $groupContainer = $yearContainer.find('.sfi-agreement-group[data-sfi-scheme-group-id="'+groupId+'"]');
	if (!$groupContainer.length) {
		// the group container doesn't yet exist for this agreement, loop through the existing groups and add at the appropriate position
		$groupContainer = $('<div class="sfi-agreement-group" data-sfi-scheme-group-id="'+groupId+'"><h6 class="sfi-agreement-group-title">'+groupTitle+'</h6></div>');
		var inserted = false;
		$yearContainer.find('.sfi-agreement-group').each(function() {
			var $group = $(this);
			var title = $group.find('h6.sfi-agreement-group-title').html();
			if (groupTitle.localeCompare(title) < 0) {
				// new group is positioned before this group, insert it before this group
				$groupContainer.insertBefore($group);
				inserted = true;
				return false;
			}
		});
		if (!inserted) {
			// we still haven't found a home for the new group, add it to the end of the year
			$groupContainer.appendTo($yearContainer);
		}
	}
	return $groupContainer;
}

function submitSfiAjaxForm($form) {
	if ($form.hasClass('inactive') || !$form[0].reportValidity || $form[0].reportValidity()) {
		var $errors = $form.find('.form-errors');
		var data = $form.serializeObject();
		data.csrf = $('#sfi-fields').data('token');
		data.schemeId = $form.data('sfi-scheme-id');
		if($('.sfi-agreement').length) {
			data.sfiAgreementId = $('.sfi-agreement').data('sfi-agreement-id');
		} else if ($('.report-entry').length) {
			data.interventionId = $('.report-entry').data('intervention-id');
		} else {
			throw new Error('Unable to determine project type'); 
		}
		if ($form.hasClass('inactive')) {
			// for any inactive actions, submit 0 for sfiValue and null for sfiAdditionApplied
			data.sfiValue = null;
			data.sfiAdditionApplied = null;
			data.deleted = true;
		}
		return $.ajax({
			url: '/ajax/clients/report/save-sfi-scheme',
			type: "POST",
			contentType: 'application/json',
			data : JSON.stringify(data),
			beforeSend: function() {
				$form.addClass('saving');
				$errors.addClass('hide').empty();
			}
		}).done(function(response) {
			if (response.deleted) {
				$form.slideUp('fast',function() {
					$form.remove();
				});
			} else {
				$form.removeClass('saving').addClass('saved');
				$form.find('.description-cell').html(response.descriptionCell);
				$form.find('.input-group-cell').html(response.inputGroupCell);
				$form.find('.payment-cell').html(response.paymentCell);
				$form.data('stored-payment',response.payment);
			}
			return Promise.resolve();
		}).fail(function(response) {
			$errors.removeClass('hide').html(response.responseJSON.error);
			$form.removeClass('saving');
			return Promise.reject();
		});
	} else {
		$form.find('.save-button').addClass('alert');
		return Promise.reject();
	}
}

function totalAgreementPayment() {
	var totalPayment = 0;
	$('.sfi-ajax-form').each(function() {
		var $form = $(this);
		if (!$form.hasClass('inactive')) {
			var $valElem = $form.find('.sfi-value');
			var $additionElem = $form.find('.sfi-addition');
			var additionIsOptional = ($valElem.data('addition-is-optional')==1);
			var additionApplied = (!additionIsOptional || $additionElem.prop('checked'));
			if (additionIsOptional && $additionElem.prop('checked') && $valElem.val() == '') {
				$valElem.val('0');
			}
			var value = $valElem.val();
			var divFactor = $valElem.data('division');
			var rate = parseFloat($valElem.data('payment-rate'));
			var maxPayment = parseFloat($valElem.data('max-payment'));
			var addition = parseFloat($valElem.data('addition'));
			var payment = (value / divFactor) * rate;
			payment = payment + (additionApplied ? addition : 0);
			if (maxPayment > 0) {
				payment = Math.min(payment,maxPayment);
			}
			totalPayment += payment;
		}
	});
	return totalPayment;
}

function updateSfiPayment($form) {
	// remove any red submit button validation warning
	$form.find('.save-button').removeClass('alert');
	var $valElem = $form.find('.sfi-value');
	var $additionElem = $form.find('.sfi-addition');
	var additionIsOptional = ($valElem.data('addition-is-optional')==1);
	var additionApplied = (!additionIsOptional || $additionElem.prop('checked'));
	if (additionIsOptional && $additionElem.prop('checked') && $valElem.val() == '') {
		$valElem.val('0');
	}
	var $paymentSpan = $form.find('.calculated-payment');
	var storedPayment = parseFloat($form.data('stored-payment'));
	var value = $valElem.val();
	var divFactor = $valElem.data('division');
	var rate = parseFloat($valElem.data('payment-rate'));
	var maxPayment = parseFloat($valElem.data('max-payment'));
	var addition = parseFloat($valElem.data('addition'));
	var payment = (value / divFactor) * rate;
	payment = payment + (additionApplied ? addition : 0);
	if (maxPayment > 0) {
		payment = Math.min(payment,maxPayment);
	}
	$paymentSpan.html(payment.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }));
	if (payment > 0 && payment == storedPayment) {
		$form.addClass('saved');
	} else {
		$form.removeClass('saved');
	}
}

function setSfiSchemeCodeFormFields() {
	var $form = $('.sfi-scheme-code-form');
	var $unit = $form.find('#sfi-scheme-unit');
	if ($unit.val() == '') {
		$form.find('.rate-configuration').addClass('hide');
		$form.find('#sfi-scheme-rate, #sfi-scheme-accuracy, #sfi-scheme-addition-amount').prop('required',false);
	} else {
		var $selectedOption = $unit.find(':selected');
		$form.find('#sfi-scheme-rate').next('.input-group-label').html($selectedOption.data('rate-suffix'));
		$form.find('#sfi-scheme-min-value, #sfi-scheme-max-value').next('.input-group-label').html($selectedOption.data('min-max-val-suffix'));
		$form.find('.rate-configuration').removeClass('hide');
		$form.find('#sfi-scheme-rate, #sfi-scheme-accuracy').prop('required',true);
		if ($form.find('#sfi-scheme-apply-addition').val() == 'none') {
			$form.find('#sfi-scheme-addition-amount').prop('required',false).closest('.cell').addClass('hide');
		} else {
			$form.find('#sfi-scheme-addition-amount').prop('required',true).closest('.cell').removeClass('hide');
		}
	}
}





